import { Link } from "react-router-dom";
import {
  externalLinks,
  footerLinks,
  socialLinks,
} from "@/mocks/site";

export default function Footer() {
  return (
    <footer className="relative bg-foreground-950 text-background-50 grain overflow-hidden">
      <div className="w-full px-5 md:px-10 lg:px-16 pt-20 pb-10">
        <div className="grid grid-cols-1 gap-14 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Link to="/" className="inline-flex items-baseline gap-1">
              <span className="font-heading text-4xl md:text-5xl font-semibold">
                CHEF
              </span>
              <span className="font-heading text-4xl md:text-5xl font-semibold text-primary-500">
                .TV
              </span>
            </Link>
            <p className="mt-4 font-heading text-lg italic text-background-50/70">
              The World of Chef Eddie G
            </p>
            <p className="mt-6 max-w-sm font-body text-sm leading-relaxed text-background-50/55">
              A digital home for a chef, a movement and a life spent following
              food, people and places around the world.
            </p>

            <div className="mt-8 flex flex-wrap gap-3">
              {socialLinks.map((s) => (
                <a
                  key={s.label}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  className="w-10 h-10 flex items-center justify-center rounded-full border border-background-50/20 text-background-50/70 transition-all duration-300 hover:border-primary-500 hover:text-primary-400 hover:-translate-y-0.5"
                >
                  <i className={`${s.icon} text-lg`} />
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3 lg:col-start-7">
            <h4 className="font-label text-[11px] uppercase tracking-label text-primary-400">
              Explore
            </h4>
            <ul className="mt-6 space-y-3">
              {footerLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="font-body text-sm text-background-50/65 transition-colors duration-300 hover:text-background-50"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-label text-[11px] uppercase tracking-label text-primary-400">
              The Worlds
            </h4>
            <ul className="mt-6 space-y-3">
              <li>
                <a
                  href={externalLinks.chefEddieG}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 font-body text-sm text-background-50/65 transition-colors duration-300 hover:text-background-50"
                >
                  Chef Eddie G
                  <i className="ri-arrow-right-up-line text-base" />
                </a>
              </li>
              <li>
                <a
                  href={externalLinks.locavorePods}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 font-body text-sm text-background-50/65 transition-colors duration-300 hover:text-background-50"
                >
                  Locavore PODS
                  <i className="ri-arrow-right-up-line text-base" />
                </a>
              </li>
            </ul>

            <h4 className="mt-10 font-label text-[11px] uppercase tracking-label text-primary-400">
              Bring Eddie
            </h4>
            <ul className="mt-6 space-y-3">
              <li>
                <Link
                  to="/invite-eddie"
                  className="font-body text-sm text-background-50/65 transition-colors duration-300 hover:text-background-50"
                >
                  Invite Eddie
                </Link>
              </li>
              <li>
                <Link
                  to="/hire-eddie"
                  className="font-body text-sm text-background-50/65 transition-colors duration-300 hover:text-background-50"
                >
                  Hire Eddie
                </Link>
              </li>
              <li>
                <Link
                  to="/submit-a-locavore"
                  className="font-body text-sm text-background-50/65 transition-colors duration-300 hover:text-background-50"
                >
                  Submit a Locavore
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 h-px w-full bg-background-50/12" />

        <div className="mt-8 flex flex-col items-center gap-5 text-center sm:grid sm:grid-cols-3 sm:items-center sm:gap-4 sm:text-left">
          <p className="font-label text-[10px] uppercase tracking-label text-background-50/40 sm:text-left">
            © {new Date().getFullYear()} CHEF.TV — The World of Chef Eddie G
          </p>

          <a
            href="https://webjoshagency.com"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Website designed by WEBJOSH AGENCY"
            className="footer-signature group inline-flex items-center justify-center gap-2 whitespace-nowrap sm:justify-self-center"
          >
            <span className="font-label text-[10px] uppercase tracking-label text-background-50/40 transition-colors duration-300 group-hover:text-background-50/70">
              Designed by
            </span>
            <span className="font-label text-[11px] uppercase tracking-label text-primary-400 transition-colors duration-300 group-hover:text-primary-300">
              WEBJOSH AGENCY
            </span>
            <i className="ri-arrow-right-up-line text-xs text-primary-400/70 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </a>

          <p className="font-label text-[10px] uppercase tracking-label text-background-50/40 sm:text-right">
            Food. People. Places. Stories.
          </p>
        </div>
      </div>
    </footer>
  );
}